export default __webpack_public_path__ + "static/sam42_finance-47de80d3f9b13da3288f06d4a822bf1f.jpg";